import { menuSeconds } from "../../constants/menu"
import PayBillTransferFee from "../../pages/payBill/payBillTransferFee"

/**
 * รายการชำระค่าโอนแผง — เมนูย่อยใต้ "สัญญาเช่าแผงค้า" (STALL)
 * ใช้หน้า payBill เดิมผ่าน prop transferFeeOnly ไม่ได้ copy หน้าใหม่
 */
const routePayBillTransferFee = [
  {
    ...menuSeconds.PAY_BILL_TRANSFER_FEE,
    /** key ต้องตรงกับ menuSecondKey ที่ backend ส่งมา ไม่งั้น AppShell หา activeMenu ไม่เจอ ปุ่มจะ disable หมด */
    key: menuSeconds.PAY_BILL_TRANSFER_FEE.key,
    name: menuSeconds.PAY_BILL_TRANSFER_FEE.name,
    textName: menuSeconds.PAY_BILL_TRANSFER_FEE.textName,
    active: false,
    appBar: true,
    component: PayBillTransferFee
  }
]

export default routePayBillTransferFee
